import { atom } from 'jotai'
import type { TProduct } from '../types/product.types'

export const productState = atom<TProduct>({
    id: 0,
    warehouse: '',
    is_enable: false,
    is_liquefy: false,
    is_service_item: false,
    is_barcode_scan_require: false,
    enable_allowbackorder: false,
    country_code: '',
    item_code: '',
    product_sorting: 0,
    item_name: {
        english: '',
        native: ''
    },
    more_info_usage: '',
    item_info_list: {
        english: [],
        native: []
    },
    item_info_link_target: '',
    item_info_link_url: {
        english: '',
        native: ''
    },
    item_info_path: {
        english: '',
        native: ''
    },
    price: 0,
    price_original: null,
    discount_amount: null,
    pv: 0,
    pvOrigin: 0,
    qty_sellable: 0,
    image_url: '',
    remarks: '',
    categories: [],
    tags: [],
    status: null,
    system_tags: [],
    tooltip: null,
    partsCount: {
        unit: {
            english: '',
            native: ''
        },
        value: 0
    },
    vat: {
        rate: 0
    },
    weight: {
        unit: '',
        value: 0
    },
    children: [],
    fg: {
        associate: {
            onetime: {
                price: 0,
                pv: 0
            },
            subscription: {
                price: 0,
                pv: 0
            }
        },
        member: {
            onetime: {
                price: 0,
                pv: 0
            },
            subscription: {
                price: 0,
                pv: 0
            }
        },
        retail: {
            onetime: {
                price: 0,
                pv: 0
            },
            subscription: {
                price: 0,
                pv: 0
            }
        }
    },
    qty: '1',
    is_free_icon: false,
    price_x_qty: {
        suffix: '',
        value: '',
        english: '',
        native: ''
    },
    pv_x_qty: {
        suffix: '',
        value: '',
        english: '',
        native: ''
    },
    selected_purchase_price: {
        value: '',
        suffix: ''
    },
    selected_purchase_pv: {
        value: '',
        suffix: ''
    },
    isShowPv: false
})
